module.exports = __webpack_public_path__ + "img/t4-10.0544fca8.svg";